import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/features/auth/hooks/useAuth";
import { tenantSettingsQueryOptions } from "@/lib/queries/tenant-settings.queries";
import { currencySymbolForCode, resolveCurrencyCode } from "@/lib/currency-display";

export function useTenantCurrency() {
  const activeTenantId = useAuth((s) => s.activeTenantId);
  const query = useQuery(tenantSettingsQueryOptions(activeTenantId));

  const code = useMemo(() => resolveCurrencyCode(query.data?.currency), [query.data?.currency]);
  const symbol = useMemo(() => currencySymbolForCode(code), [code]);

  return {
    code,
    symbol,
    isLoading: query.isLoading,
  };
}
